import React, { useMemo, useState, FC } from 'react';
import { ParticipatingLocations } from 'views/rebranded-module/common/components';
import { StyledMarkerBox } from 'views/rebranded-module/common/components/Logical/ParticipatingLocationsWrapper/ParticipatingLocationsWrapper.styles';
import Pin from 'public/imgs/mapGroups/Pin';
import { useContent } from 'views/rebranded-module/common/context/useContent';


const DEFAULT_ZOOM = 5;
const SELECTED_LOC_ZOOM = 8;
interface SelectedLocation {
  id: number;
  name: string;
  lat: string;
  lng: string;
  position: {
    lat: number;
    lng: number;
  };
  zoom: number;
  [key: string]: any; // optional if you have extra unknown props
}
const ParticipatingLocationsWrapper: FC<any> = (props) => {
  const {
    mapGroupData,
    mapGroupsTitle,
    content: propsContent,
    ...restOfProps
  } = props;
    const participatingLocationsFromUseContent = useContent('ParticipatingLocationsComponent');
    const content = participatingLocationsFromUseContent || propsContent;
  
  const locationsList = useMemo(() => {
    const groupsLocNums = mapGroupData.locations_per_place.map(
      (locationGroup) => locationGroup.locations.length,
    );
    for (let i = 1; i < groupsLocNums.length; i += 1) {
      groupsLocNums[i] += groupsLocNums[i - 1];
    }
    return mapGroupData.locations_per_place.map(
      (locationGroup, groupIndex) => ({
        name: locationGroup.place?.name,
        slug: locationGroup.place?.slug,
        locations: locationGroup.locations.map((loc, locIndex) => ({
          ...loc,
          order:
            (groupIndex - 1 >= 0 ? groupsLocNums[groupIndex - 1] : 0)
            + locIndex
            + 1,
        })),
      }),
    );
  }, [mapGroupData]);
const [selectedLocation, setSelectedLocation] = useState<SelectedLocation | null>(null);


  const [visibleLocations, setVisibleLocations] = useState(locationsList);
  const prepareMapUrl = (url) => {
    if (!url.startsWith('http')) {
      return `https://${url}`;
    }
    return url;
  };
  const handleMarkerClick = (order, location) => {
    const locationsGroupsList = document.getElementById('locationsList');
    const itemToScrollTo = document.getElementById(`item_${location.id}`);

    setSelectedLocation(() => ({
      ...location,
      position: {
        lat: Number(location.lat),
        lng: Number(location.lng),
      },
      zoom: SELECTED_LOC_ZOOM,
    }));

    locationsGroupsList.scrollTo({
      top:
        itemToScrollTo.getBoundingClientRect().top
        - locationsGroupsList.getBoundingClientRect().top
        + locationsGroupsList.scrollTop,
      behavior: 'smooth',
    });
  };
  const renderMapMarkers = () => {
    const locationsMarkers = [];

    locationsList.forEach((locationsGroup) => {
      locationsGroup.locations.forEach((location) => {
        locationsMarkers.push({
          ...location,
          ...mapGroupData.map_info.markers.find(
            (loc) => loc.id === location.id,
          ),
        });
      });
    });

    return locationsMarkers.map((locationMarker) => (
      <StyledMarkerBox
        {...locationMarker}
        lat={+locationMarker.lat}
        lng={+locationMarker.lng}
        key={locationMarker.order}
        className={`PLWMarkerCard ${
          locationMarker.id === selectedLocation?.id && 'PLWActiveMarker'
        }`}>
        <Pin className="PLWPin" />
      </StyledMarkerBox>
    ));
  };
  const handleLocationCardClick = (locationId) => {
    if (locationId === selectedLocation?.id) return;
    const newLoc = mapGroupData.map_info.markers.find(
      (mapLoc) => mapLoc.id === locationId,
    );

    if (!newLoc) return;

    setSelectedLocation(() => ({
      ...newLoc,
      position: {
        lat: Number(newLoc.lat),
        lng: Number(newLoc.lng),
      },
      zoom: SELECTED_LOC_ZOOM,
    }));
  };
  const defaultMapCenter = useMemo(
    () => ({
      lat: +mapGroupData.map_info.center.lat,
      lng: +mapGroupData.map_info.center.lng,
    }),
    [mapGroupData],
  );
  const handleTextFieldSearch = (e) => {
    const filteredLocations = [];
    const query = e.target.value;
    if (!query) {
      setVisibleLocations(locationsList);
      return;
    }
    locationsList.forEach((locationGroup) => {
      locationGroup.locations.forEach((loc) => {
        if (loc.name.toLowerCase().includes(query.toLowerCase())) {
          const foundLocGroupIdx = filteredLocations.findIndex(
            (foundLoc) => foundLoc.name === locationGroup.name,
          );
          if (foundLocGroupIdx === -1) {
            filteredLocations.push({ ...locationGroup, locations: [loc] });
          } else {
            filteredLocations[foundLocGroupIdx].locations.push(loc);
          }
        }
      });
    });
    setVisibleLocations(filteredLocations);
  };

if (!mapGroupData || mapGroupData.locations_count <= 0) return null;
  return (
    <>
      <ParticipatingLocations
        prepareMapUrl={prepareMapUrl}
        mapCenter={selectedLocation?.position || defaultMapCenter}
        handleLocationCardButtonClick={handleLocationCardClick}
        selectedLocationId={selectedLocation?.id}
        handleTextFieldSearch={handleTextFieldSearch}
        locationsGroup={visibleLocations}
        defaultZoom={selectedLocation?.zoom || DEFAULT_ZOOM}
        renderMapMarkers={renderMapMarkers}
        handleMapLogoClick={handleMarkerClick}
        mapGroupsTitle={
          mapGroupsTitle
          || content.participatingLocationsTitle

        }
        locationCount={mapGroupData.locations_count}
        {...restOfProps}
        content={content}
      />
      
    </>
  );
};

export { ParticipatingLocationsWrapper };